module.exports = __webpack_public_path__ + "img/service-image_01.02832006.jpg";